export const dialogOverrides = (width = '540px') => ({
  Content: {
    props: {
      width,
      height: 'auto',
    },
  },
});
